import ListEditor from './ListEditor'
import { useState, useMemo, useReducer } from 'react'
import { MainAppMethods } from '../../App'
import './FinderFileBatches.css'
import PagerTable from '../../common/tables/PagerTable'


export default function FinderFileBatches(props: MainAppMethods) {


    const [selectedList, setSelectedList] = useState<any>(null) // selected FinderFile list
    const [tableData, setTableData] = useState<any>({
        count: 0,
        data: [],
    }) // current data (list of lists) for table. 
    const [refresh, doRefresh] = useReducer((d) => d + 1, 0);


    // FIXME... OLX still stuck on FA V4... need to update to at least 5
    let faIconClass = sessionStorage.getItem("pencilimg") ?? ""

    const onListSaved = (list?: any) => {
        // trigger a refresh of the list by updating the refresh #   
        doRefresh();

        // if list was provided...we want to keep it open. User is continuing to edit without closing
        if (list) setSelectedList(list);
        else setSelectedList(null);

    }


    const newList = () => {
        // create a new list object for editor. 
        const l = {
            id: "0",
            batchId: "",
            firstName: "",
            lastName: "",
            fullName: "",
            addressOne: "",
            addressTwo: "",
            city: "",
            state: "",
            zipcode: "",
            keyCode: "",
            finderNumber: "",
            customerNumber: "",
            fileName: "",
            fileLineNumber: "",
            campaignID: ""
        }
        setSelectedList(l);
    }

    const columns = useMemo(
        () => [
            {
                Header: <i className='fa fa-solid fa-plus' onClick={() => newList()} />,
                accessor: 'editbtn', // accessor is the "key" in the data
                maxWidth: 30
            },
            {
                Header: 'FileName',
                accessor: 'fileName',
                maxWidth: 300
            },
            {
                Header: 'Total Records',
                accessor: "totalRecords"
            },
            {
                Header: 'SuccessRecords',
                accessor: "successRecords"
            },
            {
                Header: 'Errors Records',
                accessor: "errorRecords"
            },
            {
                Header: 'Mail Drop Date',
                accessor: "mailDropDate"
            },
            {
                Header: 'Custom Field',
                accessor: "customfieldLabel"
            },
            {
                Header: 'Created',
                accessor: "createDate"
            }
        ],
        []
    )


    const getData = (pageSize: number, pageIndex: number) => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/FinderFilesBatch?page=${pageIndex}&pageSize=${pageSize}`;
        console.log("Preparing to call api:" + _url);

        fetch(_url,
            {
                method: "GET",
                headers: props.getHeaders(),
            })
            .then(response => response.json())
            .then((resp: any) => {

                // first column will container button
                resp.data.map((d: any) => {
                    d.editbtn = <i className={faIconClass} onClick={() => setSelectedList(d)} />
                    d.mailDropDate = new Date(d.mailDropDate).toLocaleString().replace(", 12:00:00 AM","")
                    d.createDate = new Date(d.createDate).toLocaleString()
                    //d.customfield = d.customfield !== null ? "Custom " + d.customfield : d.customfield
                });

                setTableData(resp);

            });

    }

    return (
        <div style={{ "fontSize": "12px" }}>
            <PagerTable getData={getData} columns={columns} tableData={tableData} refresh={refresh} />
            {
                selectedList ? <ListEditor onListSaved={onListSaved} list={selectedList} getHeaders={props.getHeaders} /> : null
            }

        </div>

    )


}